<div class="container">
    <h1 class="mt120">herramientas ministerio cristiano en español</h1>
    <hr class="mb-0" />
</div>


<div class="mainContnet">
    <div class="container">
        <p *ngFor="let data of linkarrays"><a [routerLink]="booklink(data.linkName)"><strong>{{data.name}}</strong></a>
            <br>
            {{data.linkDescription}}
           </p>


        <div class="mt-5">
            <p class="note"><strong>Nota: </strong>iTIM cursos están diseñados para pequeños grupos de discusión. Los
                participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del
                Líder para prepararse para la discusión en grupo de 90 minutos.</p>
        </div>
    </div>
    <app-static-footer></app-static-footer>
</div>